module.exports = __webpack_public_path__ + "static/media/icon-check-white.73fcc5e5.svg";